import Vue from 'vue'
import Vuex from 'vuex'
import emailNotifications from '../api/emailNotifications'

Vue.use(Vuex)

const initialState = {
  myEmailNotifications: [],
}

const getters = {
  myEmailNotifications(state) {
    return state.myEmailNotifications
  },
}

export const actions = {
  async getEmailNotifications(contex, payload) {
    try {
      const response = await emailNotifications.getEmailNotifications(payload);
      contex.commit('myEmailNotifications', response.data, { root: true })
      return Promise.resolve();
    } catch (error) {
      if (error.response.status == 404) {
        contex.commit('myEmailNotifications', null, { root: true })
      } else {
        contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      }
      return Promise.reject(error);
    }
    // return new Promise((resolve, reject) => {
    //   emailNotifications.getEmailNotifications(payload).then((response) => {
    //     resolve();
    //     contex.commit('myEmailNotifications', response.data, { root: true })
    //   }).catch(error => {
    //     if (error.response.status == 404) {
    //       contex.commit('myEmailNotifications', null, { root: true })
    //     } else {
    //       contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
    //     }
    //     reject(error)
    //   })
    // })
  },
  async updateEmailNotifications(contex, payload) {
    try {
      const response = await emailNotifications.updateEmailNotifications(payload);
      return Promise.resolve();
    } catch (error) {
      contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
    // return new Promise((resolve, reject) => {
    //   emailNotifications.updateEmailNotifications(payload).then(() => {
    //     resolve();
    //   }).catch(error => {
    //     contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
    //     reject(error)
    //   })
    // })
  },
}

export const state = { ...initialState }

export default {
  namespaced: true,
  state,
  getters,
  actions
}
